import React from 'react'
import { URL } from '../../config'

const Video = ({platform, videoCode}) => {
  if (platform === "Youtube") {
    return (<iframe width="100%" height="180" src={`https://www.youtube-nocookie.com/embed/${videoCode}?origin=http:${URL}`} frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>)
  }

  if (platform === "Vimeo") {
    return (<iframe src={`https://player.vimeo.com/video/${videoCode}?origin=http:${URL}`} width="640" height="480" frameBorder="0" allow="autoplay; fullscreen" allowFullScreen></iframe>)
  }

  return <p>Missing video `platform`</p>
}

export default Video